import React from 'react';
const insurances = ['BlueCross BlueShield', 'Medicare', 'Medicaid', 'Aetna', 'UnitedHealthcare', 'Cigna', 'Fidelis Care'];
export function InsuranceSection() {
  return <section className="py-20 md:py-28 bg-white overflow-hidden" aria-labelledby="insurance-heading" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-12" data-id="element-211">
        <h2 id="insurance-heading" className="text-3xl md:text-4xl font-bold text-navy-500 mb-4" data-id="element-212">
          Healthcare Within Your Reach
        </h2>
        <p className="text-lg text-gray-500 max-w-2xl mx-auto" data-id="element-213">
          We accept most major insurance plans and offer financial assistance
          for those who need it.
        </p>
      </div>

      {/* Ticker Container */}
      <div className="relative w-full flex overflow-hidden mb-16 before:absolute before:left-0 before:top-0 before:z-10 before:h-full before:w-10 before:bg-gradient-to-r before:from-white before:to-transparent after:absolute after:right-0 after:top-0 after:z-10 after:h-full after:w-10 after:bg-gradient-to-l after:from-white after:to-transparent" data-id="element-214">
        <div className="flex animate-scroll whitespace-nowrap gap-4 py-4" data-id="element-215">
          {/* First set */}
          {insurances.map((insurance, idx) => <div key={`ins-1-${idx}`} className="inline-flex items-center justify-center border border-light-border rounded-lg px-8 py-4 bg-gray-50 text-sm font-semibold text-gray-600 shadow-sm min-w-[200px]" aria-label={`Accepted insurance: ${insurance}`} data-id="element-216">
              {insurance}
            </div>)}
          {/* Duplicate set for seamless looping */}
          {insurances.map((insurance, idx) => <div key={`ins-2-${idx}`} className="inline-flex items-center justify-center border border-light-border rounded-lg px-8 py-4 bg-gray-50 text-sm font-semibold text-gray-600 shadow-sm min-w-[200px]" aria-hidden="true" data-id="element-217">
              {insurance}
            </div>)}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <div className="bg-teal-500/10 border border-teal-500/20 rounded-[10px] p-6 md:p-8 max-w-2xl mx-auto text-center" data-id="element-219">
          <p className="text-teal-500 font-bold text-lg md:text-xl" data-id="element-220">
            Sliding Fee Scale Available. No one is turned away.
          </p>
        </div>
      </div>
    </section>;
}